import {
    EElementType,
    ILandingElement,
    INormalizedLandingElement,
} from '~/src/services/projects';

export const flattenTreeView = (
    body: ILandingElement[],
    parentId?: string,
    blockId?: string,
    parentRenderId?: string,
): INormalizedLandingElement => {
    const flat = (
        nodeList: ILandingElement[],
        level: number,
        parentId?: string,
        blockId?: string,
        parentRenderId?: string,
    ): INormalizedLandingElement => {
        return nodeList.reduce(
            (acc: INormalizedLandingElement, node: ILandingElement) => {
                const { title, type, properties, label, children } = node;
                const id = (parentId ? parentId + '.' : '') + title;
                const newBlockId = type === EElementType.Block ? id : blockId;
                const renderId = parentRenderId
                                    ? `${parentRenderId}.${title}`
                                    : title.replace(/\[\d+\]/, '');

                acc[id] = {
                    title,
                    renderId,
                    type,
                    properties,
                    label,
                    level,
                    parentId,
                    id,
                    blockId: newBlockId,
                    hasChildren: children?.length > 0,
                    isOpen: true,
                    isVisible: true,
                };

                if (children) {
                    const flattenNodes = flat(
                        node.children,
                        level + 1,
                        id,
                        newBlockId,
                        renderId
                    );
                    acc = { ...acc, ...flattenNodes };
                }

                return acc;
            },
            {}
        );
    };
    // TODO: deepclone вместо spread
    const stack = [...body];
    return flat(stack, !parentId ? 1 : 2, parentId, blockId, parentRenderId);
};
